import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { FcDownload } from "react-icons/fc";
import { makeStyles } from "@material-ui/core/styles";
import { FcSearch } from "react-icons/fc";
import {handleDownloadExcel} from "../ExportToExcel"

const useStyles = makeStyles({
  card: {
    maxWidth: "1100px",
    margin: "0 auto",
    backgroundColor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 1px 2px rgba(15,23,42,0.06), 0 8px 24px rgba(15,23,42,0.06)",
    overflow: "hidden",
  },
  dateInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 24px",
    borderBottom: "1px solid #e2e8f0",
  },
  dateRange: {
    color: "#1f2937",
    fontWeight: 600,
  },
  tableHeadRow: {
    "& th": {
      backgroundColor: "#f4f6fb",
      color: "#1f2937",
      fontWeight: 700,
      borderBottom: "1px solid #e2e8f0",
    },
  },
  tableRow: {
    "&:nth-child(even)": {
      backgroundColor: "#fafbfd",
    },
    "&:hover": {
      backgroundColor: "#e8f1fb",
    },
    "&:last-child td": {
      border: 0,
    },
  },
  iconBtn: {
    background: "none",
    border: "none",
    borderRadius: "50%",
    padding: 6,
    cursor: "pointer",
    display: "inline-flex",
    transition: "background-color 0.15s ease",
    "&:hover:not(:disabled)": {
      backgroundColor: "#e8f1fb",
    },
    "&:disabled": {
      cursor: "not-allowed",
      opacity: 0.5,
    },
  },
  emptyState: {
    textAlign: "center",
    padding: "24px",
    color: "#607d8b",
  },
});

const ReportResult = ({
  startDate,
  endDate,
  reports,
  userid,
  sid,
}) => {
  const classes = useStyles();

  const [exportData, setExportData] = useState({
    headers: [
      "Teachers", "Class", "Subject", "Lesson Name", "Date"
    ],
    body: []
  }
  )

  useEffect(() => {
    const myArray = (reports || []).map(item => {
      return {
        Teacher: item.Teacher,
        div_name: item.div_name,
        subject: item.subject,
        LessonName: item.LessonName,
        created_date: item.created_date ? item.created_date.substring(0, 11) : ""
      }
    });
    setExportData((prev) => ({...prev, body: myArray}))
  }, [reports])

  return (
    <div className={classes.card}>
      <div className={classes.dateInfo}>
        <span className={classes.dateRange}>
          {startDate} - {endDate}
        </span>
        <button
          type="button"
          className={classes.iconBtn}
          aria-label="Download report as Excel"
          disabled={!reports || reports.length === 0}
          onClick={()=>handleDownloadExcel(exportData.headers, exportData.body)}
        >
          <FcDownload size={24} />
        </button>
      </div>
      <TableContainer>
        <Table aria-label="weekly reports table">
          <TableHead>
            <TableRow className={classes.tableHeadRow}>
              <TableCell align="center">Teachers</TableCell>
              <TableCell align="center">Class</TableCell>
              <TableCell align="center">Subject</TableCell>
              <TableCell align="center">Lesson Name</TableCell>
              <TableCell align="center">Date</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!reports || reports.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} className={classes.emptyState}>
                  No weekly reports found for this selection.
                </TableCell>
              </TableRow>
            ) : (
              reports.map((report, idx) => (
                <TableRow key={report.id || idx} className={classes.tableRow}>
                  <TableCell align="center">{report.Teacher}</TableCell>
                  <TableCell align="center">{report.div_name}</TableCell>
                  <TableCell align="center">{report.subject}</TableCell>
                  <TableCell align="center">
                    {report.LessonName}
                  </TableCell>
                  <TableCell align="center">
                    {report.created_date ? report.created_date.substring(0, 11) : "-"}
                  </TableCell>

                  <TableCell align="center">
                    <Link
                      to={`/admin/reportWeeklyView/${sid}/${userid}/${report.id}`}
                      aria-label={`View weekly plan for ${report.Teacher}`}
                      className={classes.iconBtn}
                    >
                      <FcSearch size={24} />
                    </Link>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ReportResult;
